ACC.filter = {
  categoryUrlText: '%3Acategory%3A',
  bindAll: function() {
    var checkboxes = $(document).find('#ph-filters').find('input:checkbox'),
        isPplEnabled = $(document).find('.ph-pplFeedEnabled').data('pplfeedenabled'),
        isHhs = $('#ph-filters').data('ishhs'),
        formOption = '',
        formOptionClass = 'ph-form-option';

    $('.ph-unselect-all').addClass('ph-hidden');

    checkboxes.each(function() {
      formOption = $(this).closest('.' + formOptionClass);

      if ($(this).is(':checked')) {
        $('.ph-unselect-all').removeClass('ph-hidden');
      }

      if (isHhs && !isPplEnabled && formOption.hasClass('ph-form-child')) {
        var parentCode = $(this).data('parent');
        var $childElement = formOption;

        checkboxes.each(function() {
          var $this = $(this);

          if (parentCode === $this.attr('id')) {
            $childElement.removeClass('ph-hidden ph-form-child');
            $this.closest('.' + formOptionClass).after($childElement);
            $this.prop('checked', true).attr('disabled', true);
          }
        });
      }
    });

    $(document).on('change', '#ph-filters input:checkbox', function() {
      var urlText = $(this).data('url'),
          categoryUrlText = ACC.filter.categoryUrlText;

      if ($(this).attr('name') === 'Product Added to List' || $(this).attr('name') === 'Product Recently Ordered') {
        urlText = ACC.filter.checkStatusUrl($(this), urlText);
      }

      if ($(this).is(':checked') === false) {
        var fullName = $(this).attr('id'),
            categoryName = $(this).attr('id').substr(0, $(this).attr('id').length - 3);

        checkboxes.each(function() {
          if ($(this).attr('name') === 'subcategory' && $(this).attr('id').includes(categoryName) && $(this).is(':checked')) {
            urlText = urlText.replace(categoryUrlText + $(this).attr('id'), '');
          } else if ($(this).attr('name') === 'subcategory' && fullName === $(this).data('parent')) {
            urlText = urlText.replace(categoryUrlText + $(this).attr('id'), '');

            if (fullName) {
              urlText = urlText.replace(categoryUrlText + fullName, '');
            }
          }
        });
      }

      urlText = ACC.filter.editUrl($(this), urlText, isHhs, isPplEnabled);

      location.replace(urlText);
    });
  },
  editUrl: function(thisElement, urlText, isHhs, isPplEnabled) {
    var finalUrl = urlText;

    if (isHhs && isPplEnabled) {
      finalUrl = ACC.filter.editUrlHhsPplFeed(thisElement, urlText);
    } else if (isHhs && !isPplEnabled) {
      finalUrl = ACC.filter.editUrlHhs(thisElement, urlText);
    }

    return finalUrl;
  },
  checkStatusUrl: function(thisElement, urlText) {
    var finalUrl = urlText;

    if (thisElement.is(':checked') === false) {
      finalUrl = finalUrl.replace('%3A' + thisElement.attr('id'), '');
    }

    return finalUrl;
  },
  editUrlHhs: function($this, urlText) {
    var urlTxt = urlText,
        categoryUrlText = ACC.filter.categoryUrlText;

    if ($this.is(':checked') === true && !$this.closest('.ph-form-option').hasClass('ph-parent-category')) {
      var caValue = $this.closest('.ph-parent-wrapper').find('.ph-parent-category input').attr('id');

      urlTxt = urlTxt.replace(categoryUrlText + caValue, '');
    }

    if ($this.attr('name') === 'subcategory' && !$this.is(':checked')) {
      var isChildChecked = false;
      var parentId = '';

      $this.closest('.ph-parent-wrapper').find('input').each(function() {
        var $thisElement = $(this);

        if ($thisElement.attr('name') === 'subcategory' && $thisElement.is(':checked')) {
          isChildChecked = true;
        }

        parentId = $thisElement.data('parent');
      });

      if (!isChildChecked) {
        urlTxt = urlTxt + categoryUrlText + parentId;
      }
    }

    return urlTxt;
  },
  editUrlHhsPplFeed: function($this, urlText) {
    var urlTxt = urlText,
        fullName = $this.attr('id'),
        categoryUrlText = ACC.filter.categoryUrlText,
        isCategory = true;

    if (fullName && (fullName === 'recentOrderFacet' || fullName === 'recentListAdded')) {
      isCategory = false;
    }

    if (isCategory && fullName && $this.is(':checked') === true) {
      urlTxt = urlTxt + categoryUrlText + fullName;
    } else {
      urlTxt = urlTxt.replace(categoryUrlText + fullName, '');
    }

    return urlTxt;
  },
  clearCustomFilterButton: function(completeUrl) {
    var clearFilterUrl = '',
        searchedText = '';

    if (completeUrl.includes('recentOrderFacet') || completeUrl.includes('recentListAdded')) {
      if (completeUrl.includes('?q')) {
        clearFilterUrl = completeUrl.split('?q').splice(0, 1).join();
      }

      if (completeUrl.includes('?sort')) {
        clearFilterUrl = completeUrl.split('?sort').splice(0, 1).join();
      }

      if (completeUrl.includes('search?')) {
        searchedText = $.trim($('.ph-searched__text').attr('data-searchresult'));
        clearFilterUrl = '/search?text=' + searchedText;
      }
    } else if (completeUrl.includes('%3Acategory')) {
      clearFilterUrl = completeUrl.split('%3Acategory').splice(0, 1).join();
    }

    return clearFilterUrl;
  }
};
$(document).ready(function() {
  var parent = '',
      filterElements = '';

  $(document).on('click', '.ph-filter-popup-open', function() {
    parent = $('.ph-filter-popup');
    parent.addClass('ph-open');
    filterElements = '';
    filterElements = $('#ph-filterDesktop').find('.ph-filter').clone();
    $('.ph-filter-popup-body').html(filterElements);
  });

  $(document).on('click', '.ph-filter-popup-close', function() {
    parent = $(this).closest('.ph-filter-popup');
    parent.removeClass('ph-open');
    filterElements = '';
    filterElements = $('.ph-filter-popup-body').find('.ph-filter').clone();
    $('#ph-filterDesktop').html(filterElements);
  });

  $(document).on('click', '.ph-unselect-all', function() {
    var completeUrl = window.location.href,
        clearFilterUrl = ACC.filter.clearCustomFilterButton(completeUrl);

    location.replace(clearFilterUrl);
  });

  ACC.filter.bindAll();
});
